import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles(theme => ({
  row: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const RequestContent = ({ isPending, children, onRequest }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return isPending ? (
    <>
      <Grid className={classes.row}>
        <Typography display="block">{t('Your request has been received.')}</Typography>
        <Typography display="block">
          {t('Once available, information can be found here.')}
        </Typography>
      </Grid>
      <Grid className={classes.row}>
        <Button variant="contained" color="primary" size="small" disabled>
          {t('Requested')}
        </Button>
      </Grid>
    </>
  ) : (
    <>
      {children}
      <Grid className={classes.row}>
        <Button variant="contained" color="primary" size="small" onClick={onRequest}>
          {t('Request')}
        </Button>
      </Grid>
    </>
  );
};

RequestContent.propTypes = {
  children: PropTypes.node.isRequired,
  isPending: PropTypes.bool.isRequired,
  onRequest: PropTypes.func.isRequired,
};

export default RequestContent;
